export default __webpack_public_path__ + "static/media/Electrolytes.88f62d8b.svg";